/*
 * @author bai <ghimping@alpstein.my>
 * @link https://www.alpstein.my
 * @copyright Copyright (c) Alpstein Software
 *            _____                    _____                    _____
 *           /\    \                  /\    \                  /\    \
 *          /::\    \                /::\    \                /::\    \
 *         /::::\    \              /::::\    \               \:::\    \
 *        /::::::\    \            /::::::\    \               \:::\    \
 *       /:::/\:::\    \          /:::/\:::\    \               \:::\    \
 *      /:::/__\:::\    \        /:::/__\:::\    \               \:::\    \
 *     /::::\   \:::\    \      /::::\   \:::\    \              /::::\    \
 *    /::::::\   \:::\    \    /::::::\   \:::\    \    ____    /::::::\    \
 *   /:::/\:::\   \:::\ ___\  /:::/\:::\   \:::\    \  /\   \  /:::/\:::\    \
 *  /:::/__\:::\   \:::|    |/:::/  \:::\   \:::\____\/::\   \/:::/  \:::\____\
 *  \:::\   \:::\  /:::|____|\::/    \:::\  /:::/    /\:::\  /:::/    \::/    /
 *   \:::\   \:::\/:::/    /  \/____/ \:::\/:::/    /  \:::\/:::/    / \/____/
 *    \:::\   \::::::/    /            \::::::/    /    \::::::/    /
 *     \:::\   \::::/    /              \::::/    /      \::::/____/
 *      \:::\  /:::/    /               /:::/    /        \:::\    \
 *       \:::\/:::/    /               /:::/    /          \:::\    \
 *        \::::::/    /               /:::/    /            \:::\    \
 *         \::::/    /               /:::/    /              \:::\____\
 *          \::/____/                \::/    /                \::/    /
 *           ~~                       \/____/                  \/____/
 *
 */

import React, { Component } from "react";
import styled from "styled-components";
import PropTypes from "prop-types";
import { Button, WhiteSpace } from "antd-mobile";
import { FormattedMessage, injectIntl } from "react-intl";
import Theme from "../../../utils/Theme";

const StyledContainer = styled.div`
  max-width: ${Theme.MaxWidth};
  overflow-x: hidden;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
`;

const StyledContentContainer = styled.div`
  width: 80%;
  margin-top: 25%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
`;

const StyledTitle = styled.span`
  color: black;
  font-weight: bold;
  font-size: 1.3em;
`;

const StyledDescription = styled.span`
  color: grey;
  font-size: 0.9em;
  line-height: 1.7em;
`;

const StyledShopBtn = styled(Button)`
  width: 70%;
  && {
    cursor: pointer;
    font-size: 1em
    border-radius: 25px;
    color: white;
    background-color: ${Theme.PrimaryColor};
    box-shadow: 0 4px 6px -5px grey;
  }
`;

class EmptyItemSection extends Component {
  render() {
    const { history } = this.props;

    return (
      <StyledContainer>
        <StyledContentContainer>
          <StyledTitle>
            <FormattedMessage id="cart.empty.item.title" />
          </StyledTitle>
          <WhiteSpace size={"lg"} />
          <StyledDescription>
            <FormattedMessage id="cart.empty.item.description" />
          </StyledDescription>
          <WhiteSpace size={"xl"} />
          <WhiteSpace size={"md"} />
          <StyledShopBtn
            activeStyle={{ backgroundColor: Theme.ActivePrimary }}
            onClick={() => history.push("/shop")}
          >
            <FormattedMessage id="cart.empty.item.button.title" />
          </StyledShopBtn>
        </StyledContentContainer>
      </StyledContainer>
    );
  }
}

EmptyItemSection.propTypes = {
  intl: PropTypes.func.isRequired,
  currentLanguage: PropTypes.string.isRequired,
  changeLanguage: PropTypes.func.isRequired,
  history: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired,
  match: PropTypes.object.isRequired
};

export default injectIntl(EmptyItemSection);



// WEBPACK FOOTER //
// ./src/containers/CartPage/EmptyItemSection/index.js